import { render, staticRenderFns } from "./ThePreloader.vue?vue&type=template&id=32ec2dbe&scoped=true&"
import script from "./ThePreloader.vue?vue&type=script&lang=js&"
export * from "./ThePreloader.vue?vue&type=script&lang=js&"
import style0 from "./ThePreloader.vue?vue&type=style&index=0&id=32ec2dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ec2dbe",
  null
  
)

export default component.exports